export default [
  {
    path: '/private-webinar/available',
    name: 'Admin.PrivateWebinar.Available',
    component: () =>
      import (
        '@/views/PrivateWebinar/Available.vue'
      ),
    meta: {
      title: 'List Available Design Consulting',
    },
  },
  {
    path: '/private-webinar/rejected',
    name: 'Admin.PrivateWebinar.Rejected',
    component: () =>
      import (
        '@/views/PrivateWebinar/Rejected.vue'
      ),
    meta: {
      title: 'List Rejected Design Consulting',
    },
  },
]